// export const BASE_URL = "http://localhost:4500/";
// export const BASE_URL = "http://ec2-52-87-209-182.compute-1.amazonaws.com/";
export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4500/api/v1/dashboard/"
    : "https://api.myfitbizz.com/api/v1/dashboard/";

export default {
  // ----------------AUTH---------------//
  getAllUsers: BASE_URL + "user/list",
  signUp: BASE_URL + "auth/signup",
  signIn: BASE_URL + "auth/signin",
  blockUser: BASE_URL + "profile/update",
  updateUser: BASE_URL + "user",
  updateUserStatus: BASE_URL + "user/update-user-status",
  blockUser: BASE_URL + "user/block",
  verifyTrainer: BASE_URL + "user/verify-trainer",
  logOut: BASE_URL + "auth/logout",
  deleteUser: BASE_URL + "user",
  updateProfile: BASE_URL + "profile/update",
  createProfile: BASE_URL + "profile/create",

  // -------------- Privacy Policy -------------- //
  getPrivacyPolicies: BASE_URL + "privacy-policy/get",
  createPrivacyPolicy: BASE_URL + "privacy-policy/add",
  updatePrivacyPolicy: BASE_URL + "privacy-policy",
  deletePrivacyPolicy: BASE_URL + "privacy-policy",

  // -------------Terms & Conditions-------------//
  createTerms: BASE_URL + "terms/add",
  getTerms: BASE_URL + "terms/get",
  getAllTerms: BASE_URL + "terms/all",
  deleteTerms: BASE_URL + "terms",

  // -------------Posts-------------//
  deletePost: BASE_URL + "posts/delete",

  // -------------Feedbacks-------------//
  getAllReports: BASE_URL + "reports",
  resolveReport: BASE_URL + "reports/resolve",

  // -------------s3-------------//
  s3Upload: BASE_URL + "s3/upload",
};
